import styled, { css } from "styled-components";

export const Wrap = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.06);
  width: 100%;
  min-width: 320px;
`;

/* 상단: 좌(날짜/액션 토글 일부), 우(검색 + Menu) */
export const TopBar = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  position: sticky;
  top: 0;
  z-index: 2;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const LeftArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex-wrap: wrap;

  .date-label {
    color: #64748b;
    font-size: 12px;
    margin: 0 2px 0 8px;
    white-space: nowrap;
  }
`;

export const DividerV = styled.div`
  width: 1px;
  height: 26px;
  background: #e6ebf2;
  margin: 0 6px;
`;

/* 우측: 검색 + Menu 버튼 */
export const RightArea = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  min-width: 0;
  flex-wrap: nowrap;
`;

export const Input = styled.input`
  padding: 9px 12px;
  border: 1px solid #e7ecf3;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  color: #0f172a;
  min-width: 200px;
  max-width: 100%;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  &:focus {
    border-color: #93c5fd;
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.12);
    background: #fff;
  }
`;

export const DateInputEl = styled.input`
  padding: 8px 10px;
  border: 1px solid #e7ecf3;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  color: #0f172a;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  &:focus {
    border-color: #93c5fd;
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.12);
    background: #fff;
  }
`;

/* 좌측 라벨 패널 */
export const LabelsPane = styled.div`
  border-right: 1px solid #e5e7eb;
  overflow: hidden;
  .row {
    padding: 0 10px;
    cursor: default;
    font-weight: 600;
    color: #334155;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    user-select: none;
  }
  .row.head {
    font-weight: 800;
    color: #0f172a;
    background: #f3f6fb;
    cursor: pointer;
  }
  .row.item.odd {
    background: #ffffff;
  }
  .row.item.even {
    background: #f9fbfd;
  }
`;

/* 차트 아래 설명 바 */
export const HintBar = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 14px;
  border-top: 1px solid #eef2f7;
  background: #fbfdff;
`;

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 4px 8px;
  border-radius: 999px;
`;

/* ===== 버튼 새 디자인 (글래스+필, 부드러운 애니메이션) ===== */
export const Button = styled.button<{
  variant?: "primary" | "secondary" | "ghost";
  active?: boolean;
}>`
  --bg: linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%);
  --bd: #e6ebf4;
  --fg: #0f172a;

  ${(p) =>
    p.variant === "secondary" &&
    css`
      --bg: linear-gradient(180deg, #f8fafc 0%, #eef3fb 100%);
      --bd: #dde3ee;
      --fg: #0f172a;
    `}

  ${(p) =>
    p.variant === "ghost" &&
    css`
      --bg: transparent;
      --bd: transparent;
      --fg: #334155;
    `}

  ${(p) =>
    p.active &&
    css`
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.22) inset;
      filter: saturate(1.05);
    `}

  font-size: 12px;
  padding: 9px 12px;
  border: 1px solid var(--bd);
  border-radius: 14px;
  background: var(--bg);
  color: var(--fg);
  cursor: pointer;
  white-space: nowrap;
  transition: box-shadow 0.18s, transform 0.05s, background 0.2s,
    border-color 0.2s, filter 0.2s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 24px rgba(2, 6, 23, 0.1);
  }
  &:active {
    transform: translateY(0px);
    box-shadow: 0 4px 12px rgba(2, 6, 23, 0.1);
  }
`;

/* ===== Menu (단일 토글 버튼 + 드롭다운) ===== */
export const MenuWrap = styled.div`
  position: relative;
  display: inline-block;
`;

export const MenuBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  border-radius: 8px;
  padding: 0 12px 0 36px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #0f172a;
  cursor: pointer;
  position: relative;
  line-height: 1;
  font-weight: 700;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    transform 0.04s ease;

  &::before {
    content: "";
    position: absolute;
    left: 10px;
    width: 18px;
    height: 18px;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:hover {
    background: #f8fafc;
  }
  &:active {
    transform: translateY(1px);
  }
  &:focus-visible {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }

  padding: 0 12px 0 36px;
  border: 1px solid #e2e8f0;
  background: #ffffff;

  &.icon-menu::before {
    background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M4 12h16M4 18h16' stroke='%2363748B' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
  }
`;

export const MenuPanel = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0; /* 검색 오른쪽에 붙은 Menu에서 오른쪽 정렬 */
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(8px);
  border: 1px solid #e7ecf3;
  border-radius: 14px;
  box-shadow: 0 18px 44px rgba(2, 6, 23, 0.14);
  padding: 8px;
  min-width: 220px;
  z-index: 10;
`;

export const MenuItem = styled.button`
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  font-size: 13px;
  color: #0f172a;
  background: transparent;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;

  &:hover {
    background: #f6f9ff;
  }
`;
